import styled from "styled-components";

export const MessageImageLink = styled.a`
  display: block;
  line-height: 0;
  border-radius: 6px;
  overflow: hidden;
`;

export const MessageImageStyle = styled.img`
  display: block;
  width: auto;
  height: auto;
  max-width: ${(props) => (props.modeWebchatFull ? "392px" : "239px")};
  max-height: ${(props) => (props.modeWebchatFull ? "400px" : "260px")};
  object-fit: contain;
  object-position: center;
  border-radius: 6px;
`;
